import React from 'react';
import { history } from '../../history';
import { ROUTES } from '../../config/routes';
import { Translate as t } from '../../config/Translate';

export const SETTINGS_RETURN_PATH = `${ROUTES.ADMIN_MY_INFO}/setting`;

// 바로가기에서 넘긴 returnTo 가 설정 탭 경로와 같을 때만 그린다.
export const SettingsReturnButton = () => {
	if (history.location?.state?.returnTo !== SETTINGS_RETURN_PATH) return null;
	return (
		<button type="button" className="btn btn-outline-secondary btn-sm mt-0 me-1"
			onClick={() => history.push(SETTINGS_RETURN_PATH)}>
			{t('common.button.back')}
		</button>
	);
};

// 관리자 '내 계정 > 설정' 탭 아래에 두는 회사·알림 메일·사용자 정의 필드 설정 바로가기.
export const getAdminSettingShortcuts = ({ user, isExternalDealer }) => {
	if (isExternalDealer) return [];
	const list = [];
	if (user?.companyId) {
		list.push({
			code: 'company',
			link: `/Admin/AdminCompanyInfo/${encodeURIComponent(user.companyId)}`,
			titleKey: 'company.label.companyInfo',
		});
	}
	if (user?.adminType === 'S') {
		list.push({
			code: 'notificationEmail',
			link: '/Admin/AdminNotificationEmailSetting',
			titleKey: 'notification.label.emailSetting',
		});
	}
	list.push({
		code: 'customField',
		link: '/Admin/AdminCustomFieldList',
		titleKey: 'common.label.customField',
	});
	return list;
};

const AdminSettingShortcuts = ({ user, isExternalDealer }) => {
	const items = getAdminSettingShortcuts({ user, isExternalDealer });
	if (items.length === 0) return null;
	return (
		<div className="section mt-2">
			<h5 className="mb-1">{t('user.label.settingShortcuts')}</h5>
			{items.map(item => (
				<button key={item.code} type="button" className="btn btn-outline-primary btn-sm me-1 mb-1"
					onClick={() => history.push(item.link, { returnTo: SETTINGS_RETURN_PATH })}>
					{t(item.titleKey)}
				</button>
			))}
		</div>
	);
};

export default AdminSettingShortcuts;
